export const styles = {
  button: {
    marginTop: '10px',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spies/Components/ContactDetailsSection/style.js